import { EventEmitter, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface IAppConfig {
  isDashboardEditMode: boolean;
}

@Injectable()
export class ConfigService {

  private stateEventEmitter: Subject<IAppConfig> = new Subject<IAppConfig>();

  private config: IAppConfig = {
    isDashboardEditMode: false
  } as IAppConfig;

  public getConfig = (): Observable<IAppConfig> =>
    this.stateEventEmitter.asObservable();

  public updateEditModeState = (state: boolean): void => {
    this.config.isDashboardEditMode = state;
    this.stateEventEmitter.next(this.config);
  }
}
